import { render, staticRenderFns } from "./BaseTableLoader.vue?vue&type=template&id=0763cf5a&"
import script from "./BaseTableLoader.vue?vue&type=script&lang=js&"
export * from "./BaseTableLoader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports